import { GOOGLE_AUTH_ACTION } from '@actions/actions/authentication/google-auth-action';
import { AuthMethodScope, ProviderType } from '@lit-protocol/constants';
import { LitContracts } from '@lit-protocol/contracts-sdk';
import IpfsHash from 'ipfs-only-hash';
import { ExtendedProviderType } from '@shared/types/lit-protocol';
import { getUrls } from '@shared/utils/config/environment';
import { createDbCloudWallet } from '../db/DBCloudWalletHelpers';
import { fetchDBUser, createDBUser } from '../db/DBUserHelpers';
import getGoogleInfo from './getGoogleInfo';
export const mintPKP = async (authType, authMethod, authProvider, connectedWalletAddress, setProgressBar) => {
  var _a, _b;
  try {
    const authMethodId = await authProvider.getAuthMethodId(authMethod);
    console.log('MINT INFO 1', {
      authMethod,
      authMethodId
    });
    const paramArrays = async () => {
      const permittedAuthMethodTypes = [authMethod.authMethodType];
      const permittedAuthMethodIds = [authMethodId];
      const permittedAuthMethodScopes = [[AuthMethodScope.SignAnything]];
      const permittedAuthMethodPubkeys = ['0x'];
      const litContracts = new LitContracts();
      if (authType == ProviderType.Google || authType == 'genius-google') {
        const litActionHash = await IpfsHash.of(GOOGLE_AUTH_ACTION);
        const litActionHashAsBytes = litContracts.utils.getBytesFromMultihash(litActionHash);
        permittedAuthMethodTypes.push(2);
        permittedAuthMethodIds.push(litActionHashAsBytes);
        permittedAuthMethodPubkeys.push('0x');
        permittedAuthMethodScopes.push([AuthMethodScope.SignAnything]);
      }
      return {
        permittedAuthMethodTypes,
        permittedAuthMethodIds,
        permittedAuthMethodScopes,
        permittedAuthMethodPubkeys
      };
    };
    const {
      permittedAuthMethodTypes,
      permittedAuthMethodIds,
      permittedAuthMethodScopes,
      permittedAuthMethodPubkeys
    } = await paramArrays();
    setProgressBar && setProgressBar(20);
    const params = {
      keyType: 2,
      permittedAuthMethodTypes,
      permittedAuthMethodIds,
      permittedAuthMethodScopes,
      permittedAuthMethodPubkeys,
      addPkpEthAddressAsPermittedAddress: true,
      sendPkpToItself: true
    };
    console.log('MINT INFO 2', params, 'params');
    const txHash = await authProvider.mintPKPThroughRelayer(authMethod, params);
    console.log('MINTING TX HASH', txHash);
    setProgressBar && setProgressBar(25);
    const response = await authProvider.relay.pollRequestUntilTerminalState(txHash);
    console.log('MINTING RESPONSE', response);
    setProgressBar && setProgressBar(30);
    if (response.status !== 'Succeeded') {
      throw new Error('Minting failed');
    }
    const newPKP = {
      tokenId: response.pkpTokenId,
      publicKey: response.pkpPublicKey,
      ethAddress: response.pkpEthAddress
    };
    console.log('MINT SUCCESS', newPKP);
    let userInfo;
    if (authType === ExtendedProviderType.Google || authType == ExtendedProviderType.GoogleG) {
      userInfo = await getGoogleInfo({
        accessToken: authMethod === null || authMethod === void 0 ? void 0 : authMethod.accessToken
      });
    }
    const {
      data: existingUser
    } = await fetchDBUser({
      creationAuthMethodId: authMethodId
    });
    let userId = null;
    if (!(existingUser === null || existingUser === void 0 ? void 0 : existingUser.id)) {
      console.log('creating new user', authType, authMethodId);
      const newUser = await createDBUser({
        creation_auth_method: authType,
        creation_auth_method_id: authMethodId,
        wallet_address: connectedWalletAddress,
        email: userInfo === null || userInfo === void 0 ? void 0 : userInfo.email,
        first_name: userInfo === null || userInfo === void 0 ? void 0 : userInfo.given_name,
        last_name: userInfo === null || userInfo === void 0 ? void 0 : userInfo.family_name
      });
      userId = (_a = newUser === null || newUser === void 0 ? void 0 : newUser.data) === null || _a === void 0 ? void 0 : _a.id;
    } else {
      userId = existingUser === null || existingUser === void 0 ? void 0 : existingUser.id;
    }
    newPKP['userId'] = userId;
    const dbCloudWalletResult = await createDbCloudWallet({
      eth_address: newPKP === null || newPKP === void 0 ? void 0 : newPKP.ethAddress,
      pkp: newPKP,
      creation_auth_method: authType,
      creation_auth_method_id: authMethodId,
      lit_network: process.env.NEXT_PUBLIC_LIT_NETWORK,
      user_id: userId,
      creation_tx_hash: txHash
    });
    setProgressBar && setProgressBar(35);
    console.log('dbCloudWalletResult', dbCloudWalletResult);
    const addWalletToIndexer = await ((_b = await fetch(`${getUrls().INDEXER_URL}/portfolio/start-tracking?wallet=${newPKP === null || newPKP === void 0 ? void 0 : newPKP.ethAddress}`)) === null || _b === void 0 ? void 0 : _b.json());
    console.log('addToIndexer', addWalletToIndexer);
    return newPKP;
  } catch (err) {
    console.error('ERROR in mintPKP: ', err);
  }
  return null;
};